import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '老师名',
      placeholder: '请输入老师名'
    }
  ]
}
